import { render, staticRenderFns } from "./UploadServeData.vue?vue&type=template&id=2d98a78c&scoped=true&"
import script from "./UploadServeData.vue?vue&type=script&lang=js&"
export * from "./UploadServeData.vue?vue&type=script&lang=js&"
import style0 from "./UploadServeData.vue?vue&type=style&index=0&id=2d98a78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d98a78c",
  null
  
)

export default component.exports